import { render, staticRenderFns } from "./PlatformHeader.vue?vue&type=template&id=59e7d5c8"
import script from "./PlatformHeader.vue?vue&type=script&lang=js"
export * from "./PlatformHeader.vue?vue&type=script&lang=js"
import style0 from "./PlatformHeader.vue?vue&type=style&index=0&id=59e7d5c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports